// Copyright (c) 2020 Deere & Company

import './app-navigation.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ReportUrlMap } from '../../../home-page/report-url-map';
import { connect } from 'react-redux';
import { getReports } from '../../../home-page/repositories';
import { setReports } from '../../../shared/action-creator/reports';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';

const reportOrder = [{
    name: 'Order Information',
    url: '/order/'
}, {
    name: 'Reports',
    url: '/reports/'
}, {
    name: 'Constraints',
    url: '/constraints/'
}, {
    name: 'Parameters',
    url: '/parameters/'
}, {
    name: 'Pools',
    url: '/pools/'
}, {
    name: 'Linked Orders',
    url: '/linked-orders/'
}, {
    name: 'Other',
    url: '/other/'
}
];

export class AppNavigation extends Component {

    constructor () {

        super();

        this.state = {
            showOrderMenu: false,
            currentLocation: window.location.href
        };

    }

    componentDidMount= () => {

        this.fetchReports();

    }

    // eslint-disable-next-line no-unused-vars
    shouldComponentUpdate = ( nextProps, nextState ) => {

        let update = false;
        if ( ( nextProps.unit || {} ).name !== ( this.props.unit || {} ).name ) {

            setTimeout( () => {

                this.fetchReports();

            }, 0 );
            update = true;

        }
        if ( this.state.currentLocation !== window.location.href ) {

            this.setState( { currentLocation: window.location.href } );
            update = true;

        }
        if ( this.props.reports !== nextProps.reports ) {

            update = true;

        }
        return update;

    }

    fetchReports = () => {

        if ( this.props.unit && this.props.unit.name ) {

            const report = this.props.reports && this.props.reports[this.props.unit.name];

            if ( !report || ( this.props.reports && report.unitName !== this.props.unit.name ) ) {

                this.props.increaseCounter();
                getReports().then( response => {

                    this.props.setReports( this.props.unit.name, response );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        }

    }

    fetchUrl = report => {

        const url = ReportUrlMap[report];
        if ( url ) return url;
        return '/in-progress';

    };

    getSection = ( name, headers ) => headers.filter( item => item.name === name )

    toggle ( menuName ) {

        let orderMenu = false;
        let massUpdateMenu = '';

        if ( menuName === 'order' ? !this.state.showOrderMenu : !this.state.showMassUpdateMenu ) {

            document.addEventListener( 'click', this.handleOutsideClick, false );

        } else {

            document.removeEventListener( 'click', this.handleOutsideClick, false );

        }

        if ( menuName === 'admin' ) {

            orderMenu = !this.state.showOrderMenu;
            massUpdateMenu = false;

        }

        if ( menuName === undefined ) {

            orderMenu = false;
            massUpdateMenu = false;

        }

        this.setState( {
            showOrderMenu: orderMenu,
            showMassUpdateMenu: massUpdateMenu
        } );

    }

    render () {

        const { currentLocation } = this.state;
        const unit = this.props.unit || {};
        const unitCode = unit.name;
        const showNavigation = ( currentLocation.indexOf( '/units' ) === -1 &&
            currentLocation.indexOf( '/reping' ) === -1 &&
            currentLocation.indexOf( '/auditlog' ) === -1 &&
            currentLocation.indexOf( '/atp-setup' ) === -1 &&
            currentLocation.indexOf( '/batch-admin' ) === -1 );
        const { name } = unit;
        const { reports } = this.props;
        const headers = reports && reports[name] ? reports[name].headers : [];
        const dbType = reports && reports[name] ? reports[name].dbType : null;
        const atpTransactionURL = reports && reports[name] ? reports[name].atpTransactionURL : null;

        // Debug logging
        if (dbType === 'POSTGRESQL') {
            console.log('ATP Transaction URL:', atpTransactionURL);
        }

        return ( showNavigation && (
            <nav className="app-navigation">
                <NavLink activeClassName="selected" className="home" exact to={`/${unitCode}`}>
                    <span className="icon-home" />
                </NavLink>
                {reports && headers && headers.length > 0 && reportOrder.map( i => {

                    const links = this.getSection( i.name, headers );

                    return links.length > 0 ? (
                        <span key={i.name} className={`${window.location.href.indexOf( i.url ) !== -1 ? 'dropdown selected' : 'dropdown'}`}>
                            <span className="dropdown-span" onClick={this.toggle.bind( this, 'reports' )}>
                                {i.name}
                                <span className={this.state.showMenu ? 'icon-dropUpArrow' : 'icon-dropDownArrow'} />
                            </span>
                            <div className={`dropdown-content ${this.state.showOrderMenu ? 'show' : ''}`}>
                                {links.map( lk => (
                                    lk.children ? (
                                        <React.Fragment key={lk.name}>
                                            {lk.children.map( child => {
                                                if ( dbType === 'POSTGRESQL' && child.name === 'ATP Transaction' && atpTransactionURL ) {
                                                    return (
                                                        <a key={`${child.name}-dbType`} href={atpTransactionURL} target="_blank" rel="noopener noreferrer">
                                                            {child.name}
                                                        </a>
                                                    );
                                                }
                                                if ( this.fetchUrl( child.name ) !== '/in-progress' ) {
                                                    return (
                                                        <NavLink key={child.name} activeClassName="active" to={{ pathname: `/${unitCode}${this.fetchUrl( child.name )}`, state: child.name.replace( ' ', '-' ).toLowerCase() }}>
                                                            {child.name}
                                                        </NavLink>
                                                    );
                                                }
                                                return null;
                                            } )}
                                        </React.Fragment>
                                    ) : null
                                ) )
                                }

                            </div>
                        </span>
                    ) : null;

                } )}
                <span className="unit-selection">
                    {unit.description} ({unit.name}) - {unit.unitType}<a href="/units"><i className="fa fa-pencil" /> </a>
                </span>
            </nav>
        )
        );

    }

}

AppNavigation.propTypes = {
    unit: PropTypes.object,
    reports: PropTypes.object,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    setReports: PropTypes.func
};

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    reports: state.application.reports,
    unit: state.application.unit
} );

const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
    setReports: ( unit, reports ) => dispatch( setReports( unit, reports ) )
} );

AppNavigation.displayName = 'AppNavigation';

export default connect(
    mapStateToProps, mapDispatchToProps
)( AppNavigation );
